import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const langsmith = defineConnector({
  identifier: "langsmith",
  name: "LangSmith",
  tagLine: "Observability and evals for LLM apps",
  logo,
  protocol: "http",
  tags: ["ai", "engineering", "observability"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl || "https://api.smith.langchain.com"),
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [LangSmith](https://smith.langchain.com/), open **Settings › API Keys** and create a new key.",
        },
      ],
    },
    {
      title: "Enter your LangSmith details",
      items: [
        {
          kind: "url",
          label: "API URL",
          placeholder: "https://api.smith.langchain.com",
          helperText:
            "Leave blank for the US region. Use https://eu.api.smith.langchain.com for the EU region, or your self-hosted URL.",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          placeholder: "lsv2_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://api.smith.langchain.com"}/api/v1/sessions?limit=1`,
  },
});
